<template>
  <div>
    <VueNotifications
      position="top right"
    >
      <template #body="{ item, close }">
        <NotificationsToast :data="item" @click.native="close" />
      </template>
    </VueNotifications>
  </div>
</template>

<script>
import NotificationsToast from '@/components/Global/NotificationsToast.vue';

export default {
  name: 'Notifications',
  components: {
    NotificationsToast,
  },
};
</script>

<style lang="scss" scoped>
::v-deep .vue-notification-group {
  pointer-events: none;
  width: auto !important;
  @apply py-10 px-10;
  & > span {
    @apply flex;
    @apply flex-col;
    @apply space-y-2;
  }
}
::v-deep {
  .vue-notification-wrapper {
    overflow: unset;
  }
}
</style>
